export const SEARCH_SITTERS_LINK = 'SEARCH_SITTERS_LINK';
export const BECOME_A_SITTER_LINK = 'BECOME_A_SITTER_LINK';
export const REFER_LINK = 'REFER_LINK';
export const OUR_SERVICES_LINK = 'OUR_SERVICES_LINK';
export const DOG_TRAINING_PILOT_LINK = 'DOG_TRAINING_PILOT_LINK';
export const SEARCH_TRAINERS_LINK = 'SEARCH_TRAINERS_LINK';

type KeysAndValues =
  | 'OUR_SERVICES_LINK'
  | 'BECOME_A_SITTER_LINK'
  | 'REFER_LINK'
  | 'SEARCH_SITTERS_LINK'
  | 'DOG_TRAINING_PILOT_LINK'
  | 'SEARCH_TRAINERS_LINK';

export const LEFT_NAV_BAR_ITEMS: {
  [key in KeysAndValues]: KeysAndValues;
} = {
  SEARCH_SITTERS_LINK,
  BECOME_A_SITTER_LINK,
  REFER_LINK,
  OUR_SERVICES_LINK,
  DOG_TRAINING_PILOT_LINK,
  SEARCH_TRAINERS_LINK,
};
